<div class="unit-title">
  <h3>
    <span *ngIf="!loading">{{ unit.name }} </span>
    <mat-spinner *ngIf="loading" diameter="25"></mat-spinner>
  </h3>
</div>
<div class="divParentSearch" data-tour="analisis.buscador">
  <div class="search-content">
    <div class="searchbar">
      <button class="search_icon" (click)="filterData()">
        <i class="fas fa-search"></i>
      </button>
      <input
        class="search_input"
        [(ngModel)]="search"
        (keyup)="filterData()"
        type="text"
        [placeholder]="'Buscar casos'"
      />
      <mat-icon (click)="searchTouch = !searchTouch" class="tune"
        >tune</mat-icon
      >
    </div>
    <filter-cases-new-view
      [view]="'Case'"
      [users]="users"
      [open]="searchTouch"
    ></filter-cases-new-view>
  </div>
</div>
